/**
 * downloadPdf — fetch a PDF with the Bearer token only (no cookies: a stale
 * cookie must never override the SPA's token), then save or open it.
 * Returns true on success. Failures show the server's reason in a toast.
 */
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const handleSessionExpired = () => {
  localStorage.removeItem('access_token');
  if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
};

export async function downloadPdf(apiPath, filename = 'document.pdf', inline = false) {
  const token = localStorage.getItem('access_token');
  const url = apiPath.startsWith('http') ? apiPath : `${API}/api${apiPath.startsWith('/') ? '' : '/'}${apiPath}`;
  try {
    const res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (res.status === 401) {
      toast.error('Your session has expired — please sign in again.');
      handleSessionExpired();
      return false;
    }
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      const detail = typeof err.detail === 'string' ? err.detail : (err.detail?.message || '');
      throw new Error(detail || `PDF download failed (HTTP ${res.status})`);
    }
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    if (inline) {
      window.open(objUrl, '_blank', 'noopener');
    } else {
      const a = document.createElement('a');
      a.href = objUrl;
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    setTimeout(() => URL.revokeObjectURL(objUrl), 10000);
    return true;
  } catch (e) {
    toast.error(e?.message || 'PDF download failed');
    return false;
  }
}

export const pdfSafeName = (s) => String(s || '').replace(/[^A-Za-z0-9._-]+/g, '-');
